import { FC, HTMLAttributes, ReactNode } from 'react';
import { TableHeadContext } from '../Table';

export interface ITableHeadProps extends HTMLAttributes<HTMLTableSectionElement> {
  children?: ReactNode;
}

export const TableHead: FC<ITableHeadProps> = ({ children, className, ...props }) => (
  <TableHeadContext.Provider value={true}>
    <thead className={className} {...props}>
      {children}
    </thead>
  </TableHeadContext.Provider>
);
